enum UserRole {
	SKIPPER = 'Schipper',
	SHIPPER = 'Verlader',
	LOGISTICSERVICEPROVIDER = 'Bevrachter',
	PORTMANAGER = 'Havenbeheerder'
}

export default UserRole
